import Text from '@passkeys/ui/text';

const PropertiesTable = ({ data }: { data: Record<string, any> }) => {
  return (
    <table className="w-full">
      <tbody>
        {Object.entries(data).map(([key, value]) => (
          <tr
            key={key}
            className="border-b border-black/6 last:border-none theme-dark:border-neutral-600"
          >
            <td className="py-2 align-top">
              <Text
                className="whitespace-nowrap text-black/50 theme-dark:text-white/50"
                size={14}
              >
                {key}
              </Text>
            </td>

            <td className="py-2 pl-2 align-top">
              <Text monospace className="break-all" align="right" size={14}>
                {value}
              </Text>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PropertiesTable;
